module.exports = __webpack_public_path__ + "static/media/sparkLoginLogo.3d572846.svg";